module.exports = __webpack_public_path__ + "static/media/github.8f8edc5f.svg";